// Magazalarim — bagli satis magazalarinin yonetimi ve magazaya ozel ayarlar.
//
// NOT: /shops rotasi RAKIP magaza takibi icin kullaniliyor; bu sayfa kendi
// satis magazalarimiz icin ve /my-shops altinda.

import { useEffect, useState } from "react";
import { Store, ChevronDown, ChevronRight, Settings2 } from "lucide-react";
import { clsx } from "clsx";
import { EtsyShopsCard } from "../components/settings/EtsyShopsCard";
import { TrendyolShopCard } from "../components/settings/TrendyolShopCard";
import { ShopStrategyEditor } from "../components/settings/ShopStrategyEditor";
import { useShopStore } from "../store/shop.store";

export default function MyShopsPage() {
  const { shops, activeShopId, loadShops } = useShopStore();
  const [openShopId, setOpenShopId] = useState<string | null>(null);

  useEffect(() => { loadShops(); }, [loadShops]);

  // Ilk acilista aktif magazanin ayarlarini acik goster
  useEffect(() => {
    if (openShopId === null && activeShopId) setOpenShopId(activeShopId);
  }, [activeShopId, openShopId]);

  return (
    <div className="mx-auto max-w-3xl p-6">
      <div className="mb-6">
        <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900">
          <Store className="h-6 w-6 text-orange-500" />
          Mağazalarım
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Bağlı satış mağazalarını yönetin ve her mağaza için ayrı üretim ayarları tanımlayın.
        </p>
      </div>

      {/* Baglama / etiket / dikey / pasife alma */}
      <EtsyShopsCard />

      {/* Trendyol: OAuth yok, API Key/Secret ile baglanir */}
      <TrendyolShopCard />

      {/* Magazaya ozel uretim ayarlari */}
      {shops.length > 0 && (
        <div className="mt-6">
          <h2 className="mb-2 flex items-center gap-2 text-base font-semibold text-gray-900">
            <Settings2 className="h-4 w-4 text-indigo-600" />
            Mağazaya Özel Ayarlar
          </h2>
          <p className="mb-3 text-xs text-gray-500">
            Aynı tasarım her mağazaya kendi kurallarıyla gider: başlık şablonu, etiket
            stratejisi, fiyat ve görsel sayısı mağazadan mağazaya farklı olabilir.
          </p>

          <div className="space-y-2">
            {shops.map((shop) => {
              const isOpen = openShopId === shop.id;
              return (
                <div key={shop.id} className="overflow-hidden rounded-xl border border-gray-200 bg-white">
                  <button
                    onClick={() => setOpenShopId(isOpen ? null : shop.id)}
                    className="flex w-full items-center gap-2 px-4 py-3 text-left hover:bg-gray-50"
                  >
                    {isOpen ? <ChevronDown className="h-4 w-4 text-gray-400" /> : <ChevronRight className="h-4 w-4 text-gray-400" />}
                    <span
                      className="h-2.5 w-2.5 shrink-0 rounded-full"
                      style={{ background: shop.isActive ? shop.color || "#6366f1" : "#d1d5db" }}
                    />
                    <span className="text-sm font-medium text-gray-900">{shop.shopName}</span>
                    <span className="rounded bg-gray-100 px-1.5 py-0.5 text-[10px] text-gray-600">{shop.platform}</span>
                    <span className="rounded bg-indigo-50 px-1.5 py-0.5 text-[10px] text-indigo-700">{shop.vertical}</span>
                    {!shop.isActive && (
                      <span className="rounded bg-gray-200 px-1.5 py-0.5 text-[10px] text-gray-600">Pasif</span>
                    )}
                    {shop.id === activeShopId && (
                      <span className={clsx("ml-auto rounded bg-emerald-50 px-1.5 py-0.5 text-[10px] text-emerald-700")}>
                        Seçili
                      </span>
                    )}
                  </button>

                  {isOpen && (
                    <div className="border-t border-gray-100 p-4">
                      <ShopStrategyEditor shopId={shop.id} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
